<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <!-- Header ---------------------------------------------------------------------------- -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important">
      <div style="display: -webkit-box">
        <i
          class="fa fa-arrow-left font-weight-bold cursor-pointer display-inline m__t--7"
          style="vertical-align: top;"
          @click="$router.push('/form-data')"/>
        <img
          :src="require('@/assets/icon-sidebar/data-manager.svg')"
          class="m__l--10"
          width="32"
          height="32">
        <div class="m__l--10 p__t--2">
          <div class="label-header-access-application">
            {{ dataGroup ? dataGroup.name : 'Table Not Found' }}
          </div>
        </div>
      </div>
      <div class="d-flex m__t--30">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'general'}"
          class="tab-experience-manager m__r--35"
          @click="tabSelected = 'general'">
          GENERAL
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'privileges'}"
          class="tab-experience-manager"
          @click="tabSelected = 'privileges'">
          PRIVILEGES
        </div>
      </div>
    </div>

    <!-- Tab General ---------------------------------------------------------------------------- -->
    <div
      v-if="tabSelected === 'general'"
      class="studio-page-content">
      <div class="privilege-data-manager-container-general">

        <label> Group Name </label>
        <img
          v-if="isAdmin"
          :src="require('@/assets/icon/pencil-edit.svg')"
          class="cursor-pointer m__l--5"
          @click="openModal('name')"><br>
        <b>{{ dataGroup ? dataGroup.name : '' }}</b>
        <hr>

        <label> Description </label>
        <img
          v-if="isAdmin"
          :src="require('@/assets/icon/pencil-edit.svg')"
          class="cursor-pointer m__l--5"
          @click="openModal('desc')"><br>
        <b>{{ dataGroup ? dataGroup.description : '' }}</b>
      </div>
    </div>

    <div
      v-if="isOpenModalGeneral"
      id="modalGeneral"
      class="modal-title-list-view data">
      <div class="label-group-modal">
        {{ modeModal === 'name' ? 'Group Name' : 'Description' }}
      </div>
      <b-form-group
        v-if="modeModal === 'name'"
        :class="{'error-input' : $v.table_group_name.$error}">
        <input
          v-model="table_group_name"
          type="text"
          placeholder="Ex : t_name">
      </b-form-group>
      <b-form-group
        v-else
        :class="{'error-input' : $v.table_group_description.$error}">
        <textarea
          v-model="table_group_description"
          placeholder="Ex : This group for....." />
      </b-form-group>

      <div class="d-flex justify-content-end mt-4">
        <button
          class="button-border mr-2"
          @click="closeModalGeneral">
          Close
        </button>
        <button
          class="button-blue"
          @click="updateData">
          Apply
        </button>
      </div>
    </div>

    <!-- Tab Privileges ---------------------------------------------------------------------------- -->
    <div
      v-if="tabSelected === 'privileges'"
      class="studio-page-content">
      <v-client-table
        v-if="!load_first"
        ref="privilegesTableComponent"
        :columns="columns"
        :options="option"
        :data="data_table"
        class="jTable table-access-application table-access-privilege">

        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="openAdd">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <b-form
              inline
              @keypress.13.prevent="filter(filter_data)">
              <b-form-select
                v-model="select_type"
                :options="options_search"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-input
                ref="filterInput"
                v-model="filter_data"
                placeholder="Search"
                style="width: 250px; height: 35px"/>
            </b-form>
          </b-form>
        </div>

        <div
          slot="tablegroup_id"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ props.row.tablegroup_id }}
        </div>

        <div
          slot="name"
          slot-scope="props"
          @click="openDetail(props.row)">
          <div class="d-flex">
            <div class="m__r--7">
              <b-img
                v-if="props.row.user_info.photo_url"
                :src="props.row.user_info.photo_url"
                rounded="circle"
                alt="img"
                class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
              <b-img
                v-else
                :src="require('@/assets/logo/user1.png')"
                rounded="circle"
                alt="img"
                class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
            </div>
            <div class="m__t--5">
              <div class="privilege-user-info-fullname">{{ props.row.user_info.fullname }}</div>
              <div class="privilege-user-info-email">{{ props.row.user_info.email }}</div>
            </div>
          </div>
        </div>

        <div
          slot="privilege"
          slot-scope="props"
          @click="openDetail(props.row)">
          <span
            v-for="(item, index) in props.row.privilege"
            :key="index"
            :class="item"
            class="privilege-data-manager">
            {{ item.replace('_', ' ').toUpperCase() }}
          </span>
        </div>

        <div
          slot="created_at"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ convertDateTime(props.row.created_at) }}
        </div>

        <div
          slot="delete"
          slot-scope="props">
          <i
            v-if="isAdmin"
            class="fa fa-lg fa-trash cursor-pointer"
            @click="actionDeletePrivilege(props.row.user_company_id)"
          />
        </div>
      </v-client-table>
      <jLoadingTable v-if="load_first"/>

      <!-- Block Properties ---------------------------------------------------------------------- -->
      <div
        :class="{'show-container-properties-automation' : showProperties, 'hide-container-properties-automation' : !showProperties}"
        class="container-properties-automation">
        <div class="d-flex align-items-start justify-content-between">
          <div class="label-log-detail">Privileges</div>

          <div class="d-flex align-items-center">
            <div
              class="close-properties-automation"
              @click="hideProperties">
              <img
                :src="require('@/assets/icon/icon-close-properties.svg')"
                width="25">
            </div>
          </div>
        </div>

        <div v-if="dataSelected">
          <div class="d-flex">
            <div class="m__r--7">
              <b-img
                v-if="dataSelected.user_info.photo_url"
                :src="dataSelected.user_info.photo_url"
                rounded="circle"
                alt="img"
                class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
              <b-img
                v-else
                :src="require('@/assets/logo/user1.png')"
                rounded="circle"
                alt="img"
                class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
            </div>
            <div class="m__t--5">
              <div class="privilege-user-info-fullname">{{ dataSelected.user_info.fullname }}</div>
              <div class="privilege-user-info-email">{{ dataSelected.user_info.email }}</div>
            </div>
          </div><hr>
        </div>
        <div v-else>
          <b-form-group v-if="!user_organigram">
            <label>User</label>
            <j-single-select
              v-model="user_organigram"
              :custom="true"
              :is-async="true"
              :cache-options="false"
              :load-options="loadUserOptions"
              placeholder="Select User"
              value-format="object"
              label="email">
              <template
                slot-scope="node"
                slot="node-custom"
                class="d-flex">
                <div class="d-flex">
                  <div class="m__r--7">
                    <b-img
                      v-if="node.node.raw.photo_url"
                      :src="node.node.raw.photo_url"
                      rounded="circle"
                      alt="img"
                      class="m-1 round-bordered-img
                      img-circle staff-img image-popup-link b-page-theme td"/>
                    <span
                      v-if="!node.node.raw.photo_url"
                      class="privilege-data-manager-initial">
                      {{ getUserInitial(node.node.raw) }}
                    </span>
                  </div>
                  <div class="m__t--5">
                    <div class="privilege-user-info-fullname">{{ node.node.raw.first_name }} {{ node.node.raw.last_name }}</div>
                    <div class="privilege-user-info-email">{{ node.node.raw.email }}</div>
                  </div>
                </div>
              </template>
            </j-single-select>
          </b-form-group>
          <div
            v-if="user_organigram"
            class="d-flex">
            <div class="m__r--7">
              <b-img
                v-if="user_organigram && user_organigram.photo_url"
                :src="user_organigram.photo_url"
                rounded="circle"
                alt="img"
                class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
              <span
                v-if="user_organigram && !user_organigram.photo_url"
                class="privilege-data-manager-initial">
                {{ getUserInitial(user_organigram) }}
              </span>
            </div>
            <div class="m__t--5">
              <div class="privilege-user-info-fullname">{{ user_organigram.first_name }} {{ user_organigram.last_name }}</div>
              <div class="privilege-user-info-email">{{ user_organigram.email }}</div>
            </div>
            <div
              class="privilege-data-manager-change-user"
              @click="user_organigram = null">
              Change
            </div>
          </div>
          <hr v-if="user_organigram">
        </div>

        <div v-if="(user_organigram || dataSelected) && showContainerPrivilege">
          <div class="privilege-data-manager-access d-flex">
            <div>
              <div class="privilege-data-manager view_only">VIEW ONLY</div>
              <label>Enables a user to view only a table  in the table group.</label>
            </div>
            <div class="privilege-data-manager-access-toggle">
              <j-toggle
                v-model="data_privilege.view_only"
                class="m__t--12"/>
            </div>
          </div>

          <div
            :class="{ 'disabled': data_privilege.view_only }"
            class="privilege-data-manager-access d-flex">
            <div>
              <div class="privilege-data-manager create_table">CREATE TABLE</div>
              <label>Enables a user to create a table in the table group.</label>
            </div>
            <div class="privilege-data-manager-access-toggle">
              <j-toggle
                v-model="data_privilege.create_table"
                :disabled="data_privilege.view_only"
                class="m__t--12"/>
            </div>
          </div>

          <div
            :class="{ 'disabled': data_privilege.view_only }"
            class="privilege-data-manager-access d-flex">
            <div>
              <div class="privilege-data-manager alter_table">ALTER TABLE</div>
              <label>Enables a user to alter (<b>add, update, delete</b>) column any table in the table group.</label>
            </div>
            <div class="privilege-data-manager-access-toggle">
              <j-toggle
                v-model="data_privilege.alter_table"
                :disabled="data_privilege.view_only"
                class="m__t--12"/>
            </div>
          </div>

          <div
            :class="{ 'disabled': data_privilege.view_only }"
            class="privilege-data-manager-access d-flex">
            <div>
              <div class="privilege-data-manager delete_table">DELETE TABLE</div>
              <label>Enables a user to delete any table in the table group.</label>
            </div>
            <div class="privilege-data-manager-access-toggle">
              <j-toggle
                v-model="data_privilege.delete_table"
                :disabled="data_privilege.view_only"
                class="m__t--12"/>
            </div>
          </div>

          <div
            :class="{ 'disabled': data_privilege.view_only }"
            class="privilege-data-manager-access d-flex">
            <div>
              <div class="privilege-data-manager edit_data">EDIT DATA</div>
              <label>Enables a user to edit (<b>create, update, delete</b>) data record in the table group.</label>
            </div>
            <div class="privilege-data-manager-access-toggle">
              <j-toggle
                v-model="data_privilege.edit_data"
                :disabled="data_privilege.view_only"
                class="m__t--12"/>
            </div>
          </div>

          <div
            :class="{ 'disabled': data_privilege.view_only }"
            class="privilege-data-manager-access d-flex">
            <div>
              <div class="privilege-data-manager truncate">TRUNCATE</div>
              <label>Enables a user to truncate (<b>delete all</b>) data record in the table group.</label>
            </div>
            <div class="privilege-data-manager-access-toggle">
              <j-toggle
                v-model="data_privilege.truncate"
                :disabled="data_privilege.view_only"
                class="m__t--12"/>
            </div>
          </div>

          <div
            v-if="isAdmin"
            :class="{ 'disabled': data_privilege.view_only }"
            class="privilege-data-manager-access d-flex">
            <div>
              <div class="privilege-data-manager moderator">MODERATOR</div>
              <label>Enables a user to add privileges user in the table group.</label>
            </div>
            <div class="privilege-data-manager-access-toggle">
              <j-toggle
                v-model="data_privilege.moderator"
                :disabled="data_privilege.view_only"
                class="m__t--12"/>
            </div>
          </div>
        </div>

        <div
          :class="{'show-privilege-data-manager-access-button' : showProperties, 'hide-privilege-data-manager-access-button' : !showProperties}"
          class="privilege-data-manager-access-button">
          <button
            v-if="dataSelected && isAdmin"
            class="button-border"
            @click="actionDeletePrivilege(dataSelected.user_company_id)">
            <i class="fa fa-trash" /> Delete
          </button>

          <button
            class="button-border close-prop"
            @click="hideProperties">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jApiForm from '@/services/jApiForm';

export default {
  components: {
    jLoadingTable,
  },

  data() {
    return {
      dataGroup: null,
      tabSelected: 'general',
      showProperties: false,
      dataSelected: null,
      modeModal: 'name',

      table_group_name: null,
      table_group_description: null,

      user_organigram: null,
      data_privilege: {
        view_only: false,
        create_table: false,
        alter_table: false,
        delete_table: false,
        edit_data: false,
        truncate: false,
        moderator: false,
      },
      user_data_privilege: [],
      showContainerPrivilege: false,
      nonActiveAction: false,
      isOpenModalGeneral: false,

      load_first: true,
      filter_data: '',
      select_type: 'name',
      data_table: [],
      options_search: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Email',
          value: 'email',
        },
      ],
      columns: ['name', 'privilege', 'created_at', 'delete'],
      option: {
        headings: {
          name: 'NAME',
          privilege: 'PRIVILEGES',
          created_at: 'UPDATED DATE',
          delete: '',
        },
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
      },
      isModerator: false,
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreForm', ['privilege_by_group_data_list']),

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },
  },
  watch: {
    user_organigram(val) {
      if (val) {
        this.getDataPrivilegeByuser(val.user_company_id);
      }
    },

    table_group_name(val) {
      if (val) {
        const regexSymbol = /[^\w\s]/g;
        setTimeout(() => {
          this.table_group_name =
            val.toLowerCase()
              .replace(regexSymbol, '')
              .replace(' ', '_');
        }, 1);
      }
    },

    // eslint-disable-next-line
    'data_privilege.view_only': function (val){
      if (!this.nonActiveAction) {
        this.setPrivilegeUser(val, 'view_only');
      }
    },

    // eslint-disable-next-line
    'data_privilege.create_table': function (val){
      if (!this.nonActiveAction) {
        this.setPrivilegeUser(val, 'create_table');
      }
    },

    // eslint-disable-next-line
    'data_privilege.alter_table': function (val){
      if (!this.nonActiveAction) {
        this.setPrivilegeUser(val, 'alter_table');
      }
    },

    // eslint-disable-next-line
    'data_privilege.delete_table': function (val){
      if (!this.nonActiveAction) {
        this.setPrivilegeUser(val, 'delete_table');
      }
    },

    // eslint-disable-next-line
    'data_privilege.edit_data': function (val){
      if (!this.nonActiveAction) {
        this.setPrivilegeUser(val, 'edit_data');
      }
    },

    // eslint-disable-next-line
    'data_privilege.truncate': function (val){
      if (!this.nonActiveAction) {
        this.setPrivilegeUser(val, 'truncate');
      }
    },

    // eslint-disable-next-line
    'data_privilege.moderator': function (val){
      if (!this.nonActiveAction) {
        this.setPrivilegeUser(val, 'moderator');
      }
    },
  },
  created() {
    this.getDataGroup();
    this.getDataPrivilege();
    this.getPrivilegeByMe();
  },
  methods: {
    ...mapActions('jStoreForm', ['getListDataGroup', 'getListPrivilegeByGroup', 'getListPrivilegeByUser',
      'updateNameDataGroup', 'updateDescDataGroup', 'addPrivilege', 'removePrivilege', 'deletePrivilege',
      'getListPrivilegeByMe']),
    ...mapActions('jStoreNotificationScreen', ['toggleInfo', 'toggleProblem']),

    getDataGroup() {
      const req = {
        page: 1,
        limit: 10,
        sort: { updated_at: -1 },
        search: this.$route.params.id,
      };
      this.getListDataGroup(req).then((res) => {
        if (!res.error) {
          const detailGroup = res.data.find(f => f.id === this.$route.params.id);
          this.dataGroup = detailGroup || null;
          this.table_group_name = detailGroup ? detailGroup.name : null;
          this.table_group_description = detailGroup ? detailGroup.description : null;
        }
      });
    },

    getDataPrivilege() {
      const param = {
        page: 1,
        limit: 1000000,
        sort: { created_at: -1 },
        tablegroup_id: this.$route.params.id,
        search: '',
      };
      this.getListPrivilegeByGroup(param).then((res) => {
        if (!res.error) {
          this.data_table = res.data;
          this.load_first = false;
        }
      });
    },

    getPrivilegeByMe() {
      this.getListPrivilegeByMe({ tablegroup_id: this.$route.params.id }).then((res) => {
        if (!res.error && res.data && res.data.privilege.includes('moderator')) {
          this.isModerator = true;
        }
      });
    },

    openModal(mode) {
      this.modeModal = mode;
      this.isOpenModalGeneral = true;
      setTimeout(() => {
        const element = document.getElementById('modalGeneral');
        if (element) element.classList.add('show');
      }, 200);
    },

    closeModalGeneral() {
      this.table_group_name = this.dataGroup ? this.dataGroup.name : null;
      this.table_group_description = this.dataGroup ? this.dataGroup.description : null;

      const element = document.getElementById('modalGeneral');
      if (element) element.classList.remove('show');
      setTimeout(() => {
        this.isOpenModalGeneral = false;
      }, 200);
    },

    openAdd() {
      if (this.showProperties) {
        this.hideProperties();
        setTimeout(() => { this.showProperties = true; }, 500);
      } else {
        this.showProperties = true;
      }
    },

    openDetail(data) {
      if (this.showProperties) {
        this.hideProperties();
        setTimeout(() => {
          this.getDataPrivilegeByuser(data.user_company_id);
          this.dataSelected = data;
          this.showProperties = true;
        }, 500);
      } else {
        this.getDataPrivilegeByuser(data.user_company_id);
        this.dataSelected = data;
        this.showProperties = true;
      }
    },

    getDataPrivilegeByuser(id) {
      if (id) {
        this.nonActiveAction = true;
        const param = {
          tablegroup_id: this.$route.params.id,
          user_company_id: id,
        };
        this.getListPrivilegeByUser(param).then((res) => {
          if (!res.error) {
            this.user_data_privilege = res.data ? res.data.privilege : [];
            this.data_privilege = {
              view_only: !!this.user_data_privilege.find(f => f === 'view_only'),
              create_table: !!this.user_data_privilege.find(f => f === 'create_table'),
              alter_table: !!this.user_data_privilege.find(f => f === 'alter_table'),
              delete_table: !!this.user_data_privilege.find(f => f === 'delete_table'),
              edit_data: !!this.user_data_privilege.find(f => f === 'edit_data'),
              truncate: !!this.user_data_privilege.find(f => f === 'truncate'),
              moderator: !!this.user_data_privilege.find(f => f === 'moderator'),
            };
            this.showContainerPrivilege = true;
            setTimeout(() => {
              this.nonActiveAction = false;
            }, 500);
          }
        });
      }
    },

    setPrivilegeUser(isAdd, data) {
      const userCompanyId = this.user_organigram ? this.user_organigram.user_company_id : (this.dataSelected ? this.dataSelected.user_company_id : null);
      if (userCompanyId) {
        const param = {
          tablegroup_id: this.$route.params.id,
          user_company_id: userCompanyId,
          privilege: data,
        };
        const action = isAdd ? 'addPrivilege' : 'removePrivilege';
        this[action](param).then((res) => {
          if (!res.error && res.error_session) {
            this.toggleInfo(res.message);
          } else if (!res.error && !res.error_session) {
            this.getDataPrivilege();
          } else {
            this.toggleProblem(res.message);
          }
        });
      }
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },

    hideProperties() {
      this.user_organigram = null;
      this.dataSelected = null;
      this.data_privilege = {
        view_only: false,
        create_table: false,
        alter_table: false,
        delete_table: false,
        edit_data: false,
        truncate: false,
        moderator: false,
      };
      this.showProperties = false;
    },

    actionDeletePrivilege(id) {
      const text = 'Are you sure want to delete user privilege?';
      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const param = {
            tablegroup_id: this.$route.params.id,
            user_company_id: id,
          };
          this.deletePrivilege(param).then((res) => {
            if (res.error) {
              this.toggleProblem(res.message);
            } else {
              this.getDataPrivilege();
              this.hideProperties();
            }
          });
        }
      });
    },

    updateData() {
      if (this.modeModal === 'name') {
        const paramName = {
          id: this.$route.params.id,
          name: this.table_group_name,
        };
        this.updateNameDataGroup(paramName).then((res) => {
          if (!res.error && res.error_session) {
            this.toggleInfo(res.message);
          } else if (!res.error && !res.error_session) {
            this.dataGroup = res.data || null;
            this.table_group_name = res.data ? res.data.name : null;
            this.table_group_description = res.data ? res.data.description : null;
            const element = document.getElementById('modalGeneral');
            if (element) element.classList.remove('show');
            setTimeout(() => {
              this.isOpenModalGeneral = false;
            }, 200);
          } else {
            this.toggleProblem(res.message);
          }
        });
      } else {
        const paramDesc = {
          id: this.$route.params.id,
          description: this.table_group_description,
        };
        this.updateDescDataGroup(paramDesc).then((res) => {
          if (!res.error && res.error_session) {
            this.toggleInfo(res.message);
          } else if (!res.error && !res.error_session) {
            this.dataGroup = res.data || null;
            this.table_group_name = res.data ? res.data.name : null;
            this.table_group_description = res.data ? res.data.description : null;
            const element = document.getElementById('modalGeneral');
            if (element) element.classList.remove('show');
            setTimeout(() => {
              this.isOpenModalGeneral = false;
            }, 200);
          } else {
            this.toggleProblem(res.message);
          }
        });
      }
    },

    loadUserOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            limit: 50,
            page: 1,
            search: searchQuery,
          };
          jApiForm.listUser(reqData).then((res) => {
            const mapRes = res.map((e) => { e.id = e.user_company_id; return e; });
            if (res.length > 0) { callback(null, mapRes); }
            callback(null, false);
          });
        } else {
          callback(null, false);
        }
      }
    },

    getUserInitial(user) {
      const firstName = user.first_name ? user.first_name[0] : '';
      const lastName = user.last_name ? user.last_name[0] : '';
      const initial = `${firstName}${lastName}`;
      return initial.toUpperCase();
    },

    filter(val) {
      const key = this.select_type === 'name' ? 'fullname' : 'email';
      this.data_table = this.privilege_by_group_data_list.filter(app => app.user_info[key].toUpperCase().includes(val.toUpperCase()));
    },
  },
  validations() {
    return {
      table_group_name: { required },
      table_group_description: {},
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/data-manager/jFormConfig.vue